import React from 'react';
import type TBreadcrumbItem from './types/TBreadcrumbItem';
import Box from '../Box/Box';
import Icon from '../Icon/Icon';
import Link from '../Link/Link';
import MaskedLink from '../Link/MaskedLink';
import { TIcon } from '../../types/TStyleVariables';

const renderDefaultItem = (children: React.ReactNode, link: string, icon?: TIcon, shouldMask?: boolean) => {
  const LinkComponent = shouldMask ? MaskedLink : Link;
  return (
    <>
      <LinkComponent href={link}>
        {icon && <Icon name={icon} className="left-icon" color="text-link-default" />}
        <Box as="span" name="BreadcrumbLabel">
          {children}
        </Box>
        <Icon name="arrow-right-regular" className="right-icon" color="text-secondary" aria-hidden="true" />
      </LinkComponent>
    </>
  );
};

const renderCurrentPageItem = (children: React.ReactNode) => (
  <span className="hz-CurrentPage" role="text" aria-label={`${children}, current page.`}>
    {children}
  </span>
);

const BreadcrumbItem = ({ children, link, shouldMask = false, isCurrentPage, icon, ...props }: TBreadcrumbItem) => {
  const renderItem = () => {
    if (link) {
      return renderDefaultItem(children, link, icon, shouldMask);
    }
    if (isCurrentPage) {
      return renderCurrentPageItem(children);
    }
    return children;
  };

  return (
    <Box as="li" name="Breadcrumb" aria-current={isCurrentPage ? 'page' : undefined} {...props}>
      {renderItem()}
    </Box>
  );
};

export default BreadcrumbItem;
